import { Check, ExpandLess, ExpandMore, OpenInNew } from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'

import { getLanguage } from 'data/locale'

import logoTriangle from 'assets/logo-triangle.svg'

const AppIcon = ({ backgroundColor, color }) => (
  <span className="AppSwitcher-icon" style={{ backgroundColor }}>
    <span
      className="AppSwitcher-iconMark"
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url(${logoTriangle})`,
        maskImage: `url(${logoTriangle})`
      }}
    />
  </span>
)

const AppItem = ({
  title,
  description,
  backgroundColor,
  color,
  selected,
  href,
  onClick,
  children
}) => (
  <MenuItem
    className={`AppSwitcher-item${selected ? ' AppSwitcher-item--selected' : ''}`}
    onClick={onClick}
    component={href ? 'a' : 'div'}
    href={href}
    target={href ? '_blank' : undefined}
    rel={href ? 'noopener noreferrer' : undefined}
    aria-current={selected ? 'true' : undefined}
    disableRipple
  >
    <AppIcon backgroundColor={backgroundColor} color={color} />
    <span className="AppSwitcher-itemText">
      <span className="AppSwitcher-itemTitle">{title}</span>
      <span className="AppSwitcher-itemDescription">{description}</span>
    </span>
    {children}
  </MenuItem>
)

const AppSwitcher = ({ logoSrc, logoAlt }) => {
  const { t } = getLanguage()

  const [anchorEl, setAnchorEl] = useState(null)

  const isOpen = Boolean(anchorEl)

  const handleToggle = event => setAnchorEl(isOpen ? null : event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Button
        className={`AppSwitcher-trigger${isOpen ? ' AppSwitcher-trigger--open' : ''}`}
        aria-haspopup="true"
        aria-expanded={isOpen}
        aria-controls={isOpen ? 'app-switcher-menu' : undefined}
        aria-label={t.global.appSwitcher.title}
        onClick={handleToggle}
      >
        <span className="AppSwitcher-logo">
          <img src={logoSrc} className="App-logo" alt={logoAlt} />
        </span>
        <span className="AppSwitcher-arrow">{isOpen ? <ExpandLess /> : <ExpandMore />}</span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        className="AppSwitcher-menu"
        slotProps={{ paper: { id: 'app-switcher-menu', className: 'AppSwitcher-menuPaper' } }}
      >
        <div className="AppSwitcher-title">{t.global.appSwitcher.title}</div>
        <AppItem
          title={t.global.appSwitcher.grantConnect.title}
          description={t.global.appSwitcher.grantConnect.description}
          backgroundColor="#ffc72c"
          color="#806416"
          selected
          onClick={handleClose}
        >
          <Check className="AppSwitcher-itemAction" />
        </AppItem>
        <AppItem
          title={t.global.appSwitcher.fundingIntelligence.title}
          description={t.global.appSwitcher.fundingIntelligence.description}
          backgroundColor="#2f7d8c"
          color="#ffffff"
          href={t.global.fundingIntelligenceUrl}
          onClick={handleClose}
        >
          <OpenInNew className="AppSwitcher-itemAction" />
        </AppItem>
      </Menu>
    </>
  )
}

export default AppSwitcher
